const { template } = require('lodash');

var Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.AddShippingRate = (function () {
  var shipsFromCountryField = '[data-ships-from-country]';
  var regionSelectField = '[data-bind=\'new-shipping-rate-region\']';
  var regionChosenField = regionSelectField + ' + .chzn-container';
  var shippingRateField = '[data-bind=\'new-shipping-rate-price\']';
  var incrementalRateField = '[data-bind=\'new-shipping-rate-incremental-price\']';
  var existingRates = '[data-bind=\'existing-shipping-rates\']';
  var shippingRatesContainer = '[data-bind=\'product-shipping-fields\']';

  function regionCode() {
    return $(regionSelectField).val();
  }

  function regionName() {
    return selectedRegion().text();
  }

  function shippingRate() {
    return $(shippingRateField).val();
  }

  function incrementalShippingRate() {
    return $(incrementalRateField).val();
  }

  function regionType() {
    return selectedRegion().data('region-type');
  }

  function selectedRegion() {
    return $(regionSelectField).find('option:selected');
  }

  function validToAdd() {
    var rateValid = $.isNumeric(parseFloat($(shippingRateField).val()));
    var regionValid = $(regionSelectField).val().length > 0;

    if (!rateValid) { $(shippingRateField).addClass('ui-state-error'); }
    if (!regionValid) { $(regionChosenField).addClass('ui-state-error'); }

    return rateValid && regionValid;
  }

  function resetForm() {
    $(shippingRateField).val('');
    $(regionSelectField).find('option').first().attr('selected', true);
    $(regionSelectField).trigger('liszt:updated');
  }

  function resetErrors() {
    $(shippingRateField).add(regionChosenField).removeClass('ui-state-error');
  }

  function addShippingRate() {
    // TODO: audit
    var tpl = template($('#new-rate-template').html());

    var newRate = $(tpl({
      country_name: regionName(),
      region_code: regionCode(),
      region_type: regionType(),
      shipping_rate: shippingRate(),
      incremental_rate: incrementalShippingRate()
    }));

    selectedRegion().attr('disabled', true);

    newRate.hide();
    $('[data-new-row]').before(newRate);
    resetForm();
    newRate.fadeIn();
  }

  function countryChanged() {
    var $container = $(shippingRatesContainer);
    var url = $container.data('load-from-url') + '?' + $.param({
      country_code: $(shipsFromCountryField).val()
    });
    $container.load(url, function () {
      removeInitialRates();
      addNewLocationTooltips();
    });
  }

  function removeInitialRates() {
    $(existingRates).find('[data-shipping-rate-region]').each(function (i, element) {
      var regionType = $(element).find('[data-region-type]').val(),
        regionCode = $(element).find('[data-region-code]').val();

      toggleRegionOption(regionType, regionCode, false);
    });
  }

  function toggleRegionOption(regionType, regionCode, enabled) {
    var regionOption = $(regionSelectField).find('[data-region-type=\'' + regionType + '\'][value=\'' + regionCode + '\']');

    regionOption.attr('disabled', !enabled);
    resetForm();
  }

  function bindAddShippingRate() {
    $(document).on('click', '[data-bind=\'add-shipping-rate\']', function (e) {
      e.preventDefault();

      resetErrors();

      if (validToAdd()) {
        addShippingRate();
      }
    });
  }

  function addNewLocationTooltips() {
    var newElementsWithTips = $(shippingRatesContainer + ' .tooltip');

    $(newElementsWithTips).each(function () {
      $(this).powerTip();
    });
  }

  function bindChangeCountry() {
    $(document).on('change', shipsFromCountryField, countryChanged);
  }

  function bindRemoveShippingRate() {
    var regionCodeSelector = '[data-disable-region-code]';

    $(document).on('click', regionCodeSelector, function (event) {
      var regionType = $(event.target).data('disable-region-type');
      var regionCode = $(event.target).data('disable-region-code');

      toggleRegionOption(regionType, regionCode, true);
    });
  }

  function init() {
    bindAddShippingRate();
    bindChangeCountry();
    bindRemoveShippingRate();
    removeInitialRates();
  }

  return {
    init: init
  };
})();

$(Reverb.Listing.AddShippingRate.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/listing/add_shipping_rate.js